import { Box } from "@mui/material";
import ToolTip from "../../../ToolTip/ToolTip";
import { Icon } from "@iconify/react";
export const croTableViewHeader=[
    { field: 'sl_no', headerName: 'Serial No', width: 80 },
    { field: 'name', headerName: 'Name', width: 300 },
    { field: 'address', headerName: 'Address', width: 220,
            renderCell: (params) => {
              return (
                <ToolTip
                  expand={params.row.address}
                  content={params.row.address}
                />
              );
            },
     },
    { field: 'leadCameDate', headerName: 'Lead Cam On', width: 180 },
   
    { field: 'mob', headerName: 'Contact Number', width: 180 },
    { field: 'allCourses', headerName: 'Enrolled Courses', width: 300,
        renderCell: (params) => {
            return (
              <ToolTip
                expand={params.row.allCourses}
                content={params.row.allCourses}
              />
            );
          },
     },
     { field: 'isAssessmentTaken', headerName: 'Is Assessment Taken', width: 180 ,
        renderCell: (params) => {
            if (params.row.isAssessmentTaken == 'YES') {
              return(
                <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
               <Icon icon="healthicons:yes"width="20" height="20"  style={{color: '#45d01b', marginRight: '4px',}} />
                YES
              </Box>
              )
             
            } else if (params.row.isAssessmentTaken == 'NO') {
              return (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                  <Icon icon="healthicons:no" width="20" height="20"  style={{color: '#d01b1b', marginRight: '4px',}} />
                  NO
                </Box>
              )
            } else {
              return "UN DEFINED";
            }
          },
     },
     { field: 'assessmentTakenDate', headerName: 'Assessment Taken On', width: 180 },
     { field: 'fatherName', headerName: 'Father Name', width: 250 },
    { field: 'combinations', headerName: 'Combinations', width: 300 },
   

]